import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let CanvasserTrackingInfoComponent = {
    selector: "vcCanvasserTrackingInfo",
    templateUrl:
        "/angular/components/canvasser-tracking/canvasser-tracking-info.component.html",
    bindings: {},
    controller: class CanvasserTrackingInfoController {
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        close(): void {
            this.dialog.cancel();
        }

        distanceColor(canvass: any): string {
            if (canvass.accuracy > 100) return "#bbb";
            if (canvass.distance < 100) return "#149364";
            if (canvass.distance < 300) return "orange";

            return "red";
        }
    },
};

angular
    .module("canvasserTracking")
    .component(
        CanvasserTrackingInfoComponent.selector,
        CanvasserTrackingInfoComponent
    );
